import * as chrono from 'chrono-node'
import cx from 'classnames'
import TextInput from 'components/TextInput'
import { Form, useFormikContext } from 'formik'
import { chronoDate } from 'schema/date'
import * as yup from 'yup'
import DateInput from '../../DateInput'

const casualGbChrono = new chrono.Chrono(chrono.en.createCasualConfiguration(true))

export interface FormValues {
  startDate: string
  endDate: string
  ref: string
}

export const validationSchema = yup.object().shape({
  startDate: chronoDate(casualGbChrono).label('Start date').typeError('Not a valid date').required(),
  endDate: chronoDate(casualGbChrono).label('End date').typeError('Not a valid date').required(),
  ref: yup.string().label('Reference').required(),
})

const MultiUseDiscountCodeForm = () => {
  const formik = useFormikContext<FormValues>()

  return (
    <Form>
      <DateInput name="startDate" label="Start Date" chronoInstance={casualGbChrono} />
      <DateInput name="endDate" label="End Date" chronoInstance={casualGbChrono} />

      <TextInput name="ref" label="Reference" type="text" />

      <div className="buttons">
        <button
          type="submit"
          className={cx('button is-primary', {
            'is-loading': formik.isSubmitting,
          })}
        >
          Create Discount Code
        </button>
      </div>
    </Form>
  )
}

export default MultiUseDiscountCodeForm
